export default __webpack_public_path__ + "static/media/rachel.5c0781e4.jpg";